import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import img from "../../../assets/IMG_3971.JPG";

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const faqRef = useRef(null);

  const toggleAnswer = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const questions = [
    {
      question: "1. Czy Trening EMS jest bezpieczny? To boli?",
      answer:
        "Jeśli trener jest doświadczony (mamy jedynie takich) to odpowiednio dobiera impuls i to NIE BOLI. Jest całkowicie bezpieczne, ponieważ EMS miał swoje początki jako zastosowanie w rehabilitacji i fizjoterapii.",
    },
    {
      question: "2. Czy to faktycznie daje efekty? Kolejny chwyt marketingowy?",
      answer:
        "Daje niesamowite efekty! Główną ideą tego treningu jest skoncentrowanie się na efektywnym pobudzaniu mięśni, przy jednoczesnym minimalizowaniu obciążenia stawów i ryzyka kontuzji.<br /><br />Podczas treningu EMS, osoba ćwicząca jest podłączana do urządzenia wyposażonego w elektrody, które wysyłają impulsy elektryczne do mięśni. Te impulsy pomagają mózgowi efektywniej przekazywać sygnały do mięśni, co sprawia, że mięśnie pracują intensywnie, podobnie jak w trakcie tradycyjnych ćwiczeń. Jednak w przypadku treningu EMS impulsy te są przekazywane z jeszcze większą precyzją.<br /><br />To oznacza, że podczas treningu EMS można osiągnąć pełne wykorzystanie potencjału mięśniowego, bez konieczności korzystania z ciężarów czy innych obciążeń. Dzięki temu, trening EMS jest przyjazny dla stawów i minimalizuje ryzyko kontuzji.",
    },
    {
      question: "3. Dla kogo jest trening EMS?",
      answer:
        "Trening EMS jest odpowiedni dla osób w każdym wieku, niezależnie od poziomu zaawansowania.",
    },
    {
      question: "4. Jakie są zalety treningu EMS?",
      answer:
        "Najważniejszą zaletą treningu EMS jest jego efektywność w kwestii aktywacji mięśni. Średnio angażuje on aż 8 różnych grup mięśniowych, włączając te, które znajdują się głęboko wewnątrz ciała i są trudne do osiągnięcia podczas tradycyjnych ćwiczeń.<br /><br />Ponadto, trening EMS wspomaga redukcje wagi, a nawet trzy razy szybciej niż tradycyjne formy aktywności fizycznej (choć warto zaznaczyć, że wyniki mogą się różnić w zależności od indywidualnych czynników).<br /><br />EMS jest innowacyjną metodą, która umożliwia intensywną pracę mięśni, minimalizując jednocześnie ryzyko kontuzji. Dzięki precyzyjnemu działaniu elektrod i skupieniu na aktywacji mięśni, trening ten może przynieść szybkie i efektywne wyniki dla osób pragnących poprawić swoją formę.",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once the element is visible
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (faqRef.current) {
      observer.observe(faqRef.current);
    }

    return () => {
      if (faqRef.current) {
        observer.unobserve(faqRef.current);
      }
    };
  }, []);

  return (
    <section ref={faqRef} className="bg-[#191919] text-white pt-[100px] px-5">
      <motion.div
        className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8"
        initial={{ opacity: 0, y: 50 }}
        animate={isVisible ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        {/* Left Block: FAQ */}
        <div>
          <motion.h2
            className="text-5xl font-bold mb-5 text-center"
            initial={{ x: -50, opacity: 0 }}
            animate={isVisible ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6 }}
          >
            FAQ
          </motion.h2>
          <motion.p
            className="text-lg mb-8 text-center"
            initial={{ x: -50, opacity: 0 }}
            animate={isVisible ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Często zadawane pytania
          </motion.p>
          <motion.ul
            className="space-y-4"
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {questions.map((item, index) => (
              <li key={index}>
                <h3
                  className="font-semibold text-xl cursor-pointer border-t-gray-600 border-t px-2 pt-2 flex justify-between items-center"
                  onClick={() => toggleAnswer(index)}
                >
                  <span>{item.question}</span>
                  <span>{expandedIndex === index ? "-" : "+"}</span>
                </h3>
                <motion.p
                  className="text-gray-400"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{
                    height: expandedIndex === index ? "auto" : 0,
                    opacity: expandedIndex === index ? 1 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                  style={{ overflow: "hidden" }}
                  dangerouslySetInnerHTML={{
                    __html: expandedIndex === index ? item.answer : "",
                  }}
                />
              </li>
            ))}
          </motion.ul>
        </div>

        {/* Right Block: Image */}
        <motion.div
          className="flex justify-center items-end"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={isVisible ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img
            src={img}
            alt="EMS Training"
            className="rounded-lg shadow-lg object-cover p-5"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default FAQ;
